import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient,HttpParams,HttpEventType,HttpResponse,HttpRequest,HttpHeaders} from '@angular/common/http';
import { environment as configs } from 'src/environments/environment';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit {

  constructor(private rt:Router,private httpClient:HttpClient) { }
  userinfo;
  Role;
  username;
  navrole=[];
  CircleName:any;
  ngOnInit() {
    this.userinfo=JSON.parse(localStorage.getItem('user'))
    
    this.CircleName=this.userinfo.CircleName;
    if(this.userinfo.ELRole=='BACO'){
      this.Role='BACO'
      this.username=this.userinfo.username
    }else if(this.userinfo.role==1004){
      this.Role='Inspector'
      this.username=this.userinfo.username
    }else if (this.userinfo.role==1005){
      this.Role='ALC'
      this.username=this.userinfo.username
    }else if (this.userinfo.role==1001){
      this.Role='Head Office'
      this.username=this.userinfo.username
    }else if (this.userinfo.role==1009){
      this.Role='Dealing Hand'
      this.username=this.userinfo.username
    }else if (this.userinfo.role==1010){
      this.Role='DCFA'
      this.username=this.userinfo.username
    }
    else if (this.userinfo.role==1041){
      this.Role='DGRP'
      this.username=this.userinfo.username
    }
    else if (this.userinfo.role==1042){
      this.Role='BWAD'
      this.username=this.userinfo.username
    }
    else if (this.userinfo.role==1022){
      this.Role='ADRF'
      this.username=this.userinfo.username
    }
    else if (this.userinfo.role==1023){
      this.Role='DDRF'
      this.username=this.userinfo.username
    }
    // this.navrole=[
    //   {ELRole:'Inspector', role:'1004'},
    //   {ELRole:'ALC', role:'1005'},
    //   {ELRole:'ALC', role:'1005'}
    // ];
    
  }
     host=configs['ApiHost'];
  	logout(){
  		localStorage.removeItem('auth-token');
  		localStorage.removeItem('user');
      localStorage.removeItem('isLoggedIn');
  		this.httpClient.post(this.host+'/logout',{},{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).subscribe(resp=>{});
      window.location.href='http://bocw.punjab.gov.in';

  	}


    showTo(role){

      return ((role.indexOf(this.userinfo.role.toString())>-1) || (role.indexOf(this.userinfo.ELRole.toString())>-1) )

    }

    goschemeforms(){
      this.rt.navigate(['/worker/scheme-view-forms-ex'],{queryParams:{id:37}})
    }
}
